import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopQSR = dynamic(() => import('../../components/restaurants/qsr/DesktopQSR'), {
  loading: () => <Loading />,

});
const MobileQSR = dynamic(() => import('../../components/restaurants/qsr/MobileQSR'), {
  loading: () => <Loading />,

});

const qsr = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>QSR POS Billing Software and Fast Food POS Billing Software</title>
        <link rel="canonical" href="https://queuebuster.co/restaurants/quick-service-restaurants-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/restaurants/quick-service-restaurants-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Enhance your quick service restaurant with specialized management software and efficient fast food POS billing software & solutions. Call us & Book a free demo" />
        <meta property="og:title" content="Quick Service Restaurant Management Software |  Fast Food POS Billing Software" />
        <meta property="og:description" content="Enhance your quick service restaurant with specialized management software and efficient fast food POS billing solutions. Streamline operations, manage orders, and boost efficiency for a seamless customer experience." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/qsr.jpg" />
        <meta property="og:url" content="https://queuebuster.co/restaurants/quick-service-restaurants-pos-billing-software" />
      </Head>
         <SchemaTags page="quick-service-restaurants-pos-billing-software" />
      {
        mobileView ? <MobileQSR /> : <DesktopQSR />
      }
    </>
  )
}

export default qsr